/**
 * Widget Origin Constants
 * 
 * Centralized definition of widget component origins for request tracking.
 * These values are sent to the API and attached to Langfuse traces.
 */
export const WIDGET_ORIGIN = {
  SEARCH_BOX: "search-box",
  LANDING_SEARCH_BOX: "landing-search-box",
  CONTEXT_TRIGGER: "context-trigger",
  DRAWER: "drawer",
} as const;

export type WidgetOrigin = (typeof WIDGET_ORIGIN)[keyof typeof WIDGET_ORIGIN];
